/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import MaterialDispatchListSection from "./MaterialDispatchListSection";
import {permissionObj} from "../../../../../../Helpers/permission";
import routes from "../../../../../../Routes/routes";
import DivContainerBody from "../../../../../../components/DivContainerBody";
import HeadTittle from "../../../../../../components/HeadTittle";
import MaterialDispatchApp from "../../../Functionality/MaterialRequest/MaterialDispatchApp";
import MaterialRequestDetailsSectionInfo from "../Details/MaterialRequestDetailsSectionInfo";
import ButtonAction from "../../../../../../components/buttons/ButtonAction";
import {EditIcon, IconDocumentWarning} from "../../../../../../components/buttons/IconButtons";
import CancelModal from "../../../../Dining/Schedules/Modal/CancelModal";
import {STATUS_MODEL} from "../../../../../../enums/statusEnum";
import MaterialDispatchBadge from "./MaterialDispatchBadge";

const MaterialDispatch = () => {
    const {
        t,
        navigate,
        DEV,
        isGuard,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        evidence,
        showBadge,
        showConfirmModal,
        setShowConfirmModal,
        dispatchStatusId,
        setModified,
        emptyFields,
        openDispatchModal,
        openReportModal,
        handleActionModal,
        goBack
    } = MaterialDispatchApp();

    if (!DEV && !isGuard &&
        !permission?.includes(permissionObj.WEB_MATERIAL_REQUEST_READ)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'material_dispatch'} onBack={goBack}>
                { (DEV || isGuard || permission?.includes(permissionObj?.WEB_MATERIAL_REQUEST_MANAGE)) &&
                    ![STATUS_MODEL.DISPATCHED, STATUS_MODEL.DISCREPANCY].includes(item?.dispatchStatusId) &&
                    [
                        <ButtonAction
                            id='btn_md_dispatch'
                            className='btn-icon-edit'
                            Icon={EditIcon}
                            name='dispatch'
                            onClick={() => openDispatchModal()}
                        />,
                        <ButtonAction
                            id='btn_md_report'
                            className='btn-icon-delete'
                            Icon={IconDocumentWarning}
                            name='report'
                            onClick={() => openReportModal()}
                        />
                    ]
                }
            </HeadTittle>
            <DivContainerBody>
                <div className={"mb-4"}>
                    <MaterialDispatchBadge
                        t={t}
                        showBadge={showBadge}
                        dispatchStatusId={item?.dispatchStatusId}
                        dispatchReason={item?.dispatchReason}
                        dispatchDate={item?.dispatchDate}
                        dispatchUser={item?.dispatchUser}
                    />
                </div>
                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <MaterialRequestDetailsSectionInfo
                            item={item}
                            evidence={evidence}
                            contentCardRef={contentCardRef}
                        />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        {/* The evidence of a material is uploaded at the gate,
                            so it is only read from the review of the folio. */}
                        <MaterialDispatchListSection
                            contentTableRef={contentTableRef}
                            data={item}
                            setModified={setModified}
                            emptyFields={emptyFields}
                            disabled={true}
                            cardStatusId={item?.dispatchStatusId}
                        />
                    </div>
                </div>
            </DivContainerBody>

            { showConfirmModal &&
                <CancelModal
                    show={showConfirmModal}
                    onHide={() => setShowConfirmModal(false)}
                    onConfirm={(e, comment) => handleActionModal( comment)}
                    requiredComment={dispatchStatusId === STATUS_MODEL.DISCREPANCY}
                    title_modal={dispatchStatusId === STATUS_MODEL.DISPATCHED ? "approve_dispatch" : "report_dispatch"}
                    description={t("are_you_sure_to_proceed")}
                    subDescription={t("please_provide_the_required_information_below")}
                />
            }
        </>
    );
};

export default MaterialDispatch;
